import { createSyncAction } from '@bimser/core';
import * as ActionTypes from './actionTypes';
import { IWebInterfaceAction, WebInterfaceActionFactoryFromJS } from 'common/entities';

export default function onActionSelectFileModalTransaction(data: IWebInterfaceAction) {
	if (!data) {
		return undefined;
	}

	const payload = WebInterfaceActionFactoryFromJS(data);

	const action = createSyncAction(ActionTypes.ON_ACTION_SELECT_FILE_MODAL_TRANSACTION, payload);

	return action;
}
